import { IPriceDetails, IRootState } from '@/@types'

import { GetterTree } from 'vuex'

const getters: GetterTree<IPriceDetails, IRootState> = {
  getCurrencySymbol: state => {
    return state.currencySymbol
  },
  getCurrencyCode: state => {
    return state.currencyCode
  },
  getDiscount: state => {
    return state.discount
  },
  getDiscountStr: state => {
    return state.discountStr
  },
  getSubtotal: state => {
    return state.subtotal
  },
  getSubtotalStr: state => {
    return state.subtotalStr
  },
  getTaxes: state => {
    return state.taxes
  },
  getTaxesStr: state => {
    return state.taxesStr
  },
  getTotal: state => {
    return state.total
  },
  getTotalStr: state => {
    return state.totalStr
  },
  getShowPromotionSavings: state => {
    return state.showPromotionSavings
  },
}

export default getters
